import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX } = FiIcons;

function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    'https://i.ibb.co/ZRL48K3V/image-1.jpg',
    'https://i.ibb.co/XxTqchcV/image-1.png',
    'https://i.ibb.co/FkV7pSDn/image-2.jpg',
    'https://i.ibb.co/SDptWr0v/image-2.png',
    'https://i.ibb.co/6cr4L0Kd/image-3.jpg',
    'https://i.ibb.co/k2rf0cqg/image-4.jpg',
    'https://i.ibb.co/Pz3sc2XC/image-5.jpg',
    'https://i.ibb.co/qY69NfDJ/image-6.jpg',
    'https://i.ibb.co/35hRxtj8/image-7.jpg',
    'https://i.ibb.co/YBGjjXGP/image-8.jpg',
    'https://i.ibb.co/PZz1H1Hr/image-9.jpg',
    'https://i.ibb.co/d0n7rV64/image-10.jpg',
    'https://i.ibb.co/PzGL97qz/image-11.jpg',
    'https://i.ibb.co/d0d1HFjB/image-12.jpg',
    'https://i.ibb.co/QvgQGR7T/image-13.jpg',
    'https://i.ibb.co/r2YxF6Cg/image-14.jpg',
    'https://i.ibb.co/3mgjbWw5/image-15.jpg',
    'https://i.ibb.co/qFhdkyRF/image-16.jpg',
    'https://i.ibb.co/tPqWsYPJ/image-17.jpg',
    'https://i.ibb.co/0y0VGvJz/image-18.jpg',
    'https://i.ibb.co/cK4HxxVt/image-19.jpg',
    'https://i.ibb.co/vxsRcn41/image-20.jpg',
    'https://i.ibb.co/mrFGxW4T/image-21.jpg',
    'https://i.ibb.co/WNf7RXJ8/image-23.jpg',
    'https://i.ibb.co/HTq7NX5V/image-24.jpg',
    'https://i.ibb.co/C56QV3xP/image-25.jpg',
    'https://i.ibb.co/qLWx3J8R/image-26.jpg',
    'https://i.ibb.co/NnNPmFpH/image-27.jpg',
    'https://i.ibb.co/yGbs0DP/image-28.jpg',
    'https://i.ibb.co/XZ7r7Vc0/image-29.jpg',
    'https://i.ibb.co/FqNNmkMj/image-30.jpg',
    'https://i.ibb.co/cSFt93bp/image-31.jpg',
    'https://i.ibb.co/DPR9xj54/image-32.jpg',
    'https://i.ibb.co/xKWLHwpq/image-33.jpg',
    'https://i.ibb.co/wrr08H0D/image-34.jpg',
    'https://i.ibb.co/chdyz0mR/image-35.jpg',
    'https://i.ibb.co/LDM57QP8/image-36.jpg',
    'https://i.ibb.co/QF6yLPLD/image-37.jpg',
    'https://i.ibb.co/SXX0MQNs/image-38.jpg',
    'https://i.ibb.co/k20qF7L1/image-39.jpg',
    'https://i.ibb.co/KkxYr8h/image-40.jpg',
    'https://i.ibb.co/C3HD5rVc/image-41.jpg',
    'https://i.ibb.co/vvzksHDP/image-42.jpg',
    'https://i.ibb.co/whK7GRwf/image-43.jpg',
    'https://i.ibb.co/rRxpzp9F/image-44.jpg',
    'https://i.ibb.co/3Yv1Z0F9/image-45.jpg',
    'https://i.ibb.co/qYcXtVTr/image-46.jpg',
    'https://i.ibb.co/N26pp7KL/image-47.jpg',
    'https://i.ibb.co/j9khQYMB/image-48.jpg',
    'https://i.ibb.co/Q7SBBp7X/image-49.jpg',
    'https://i.ibb.co/ymcXThxH/image-50.jpg',
    'https://i.ibb.co/0phnWr1V/image-51.jpg',
    'https://i.ibb.co/DPYgVtcb/image-52.jpg',
    'https://i.ibb.co/dRw85BB/image-53.jpg',
    'https://i.ibb.co/4wRv3DLK/image-54.jpg',
    'https://i.ibb.co/tMRDYgdd/image-55.jpg',
    'https://i.ibb.co/qL4MqqCT/image-56.jpg',
    'https://i.ibb.co/MDZqPJGP/image-57.jpg',
    'https://i.ibb.co/6pK1G52/image-58.jpg',
    'https://i.ibb.co/TB2Z7K3Z/image-59.jpg',
    'https://i.ibb.co/pjFL5jhv/image-60.jpg',
    'https://i.ibb.co/HT2Fts35/image-61.jpg',
    'https://i.ibb.co/FqwZZgJf/image-62.jpg',
    'https://i.ibb.co/Q7jw8dt0/image-63.jpg',
    'https://i.ibb.co/5hFmz2ff/image-64.jpg',
    'https://i.ibb.co/G3dC1y4m/image-65.jpg',
    'https://i.ibb.co/j9hHt8Db/image-66.jpg'
  ];

  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  return (
    <motion.div 
      className="pt-16"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div {...fadeInUp}>
            <h1 className="text-4xl md:text-6xl font-bold mb-6">Gallery</h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Explore our work and see the quality craftsmanship that sets us apart. 
              Each image showcases our dedication to excellence in men's grooming.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {images.map((image, index) => (
              <motion.div
                key={index}
                className="aspect-square overflow-hidden rounded-lg cursor-pointer"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: (index % 12) * 0.05 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
                onClick={() => setSelectedImage(image)}
              >
                <img 
                  src={image} 
                  alt={`Gallery ${index + 1}`}
                  className="w-full h-full object-cover hover:brightness-110 transition-all duration-300"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Modal */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <motion.div
              className="relative max-w-4xl max-h-full"
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.5, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute top-4 right-4 text-white hover:text-gray-300 z-10"
                onClick={() => setSelectedImage(null)}
              >
                <SafeIcon icon={FiX} className="h-8 w-8" />
              </button>
              <img 
                src={selectedImage} 
                alt="Gallery Preview"
                className="max-w-full max-h-full object-contain rounded-lg"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* CTA Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Impressed by Our Work?
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              Book your appointment today and experience the same level of quality and attention to detail.
            </p>
            <a 
              href="tel:+971504261841"
              className="bg-white text-gray-900 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
            >
              Book Now - +971 50 426 1841
            </a>
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
}

export default Gallery;